// extracted by mini-css-extract-plugin
module.exports = {"root":"_2rcQ3","wrapper":"_2uBgc","autosuggestWrapper":"_1NF1t","imageWrapperAudio":"_2qS0c","imageWrapper":"_2Udql","seoHeader":"_3IUKn","image":"_2PR9B"};